import React from "react";
export default function AboutUs() {
  return (
    <div className="product-list2">
      <h1>درباره ما</h1>
    </div>
  );
}
